module.exports = __webpack_public_path__ + "assets/menu.c5957de9.svg";